import { render, staticRenderFns } from "./workspace.vue?vue&type=template&id=794ddb93&scoped=true&lang=pug&"
import script from "./workspace.vue?vue&type=script&lang=js&"
export * from "./workspace.vue?vue&type=script&lang=js&"
import style0 from "./workspace.vue?vue&type=style&index=0&id=794ddb93&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794ddb93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('794ddb93', component.options)
    } else {
      api.reload('794ddb93', component.options)
    }
    module.hot.accept("./workspace.vue?vue&type=template&id=794ddb93&scoped=true&lang=pug&", function () {
      api.rerender('794ddb93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/position/align/workspace.vue"
export default component.exports